export interface ParameterDetailEntity {
    id:number,
    key: string,
    versionIdentifier: {
        version?: string
    },
    parentDtlId?: number | null,
    parameterId: number | null,
    parameterDtlCode: string,
    parameterDtlDesc?: string | null,
    activeInd: "Y" | "N",

    [key: string]: string | boolean | number | null | undefined | Object
}

export const EMPTY_PARAMETER_DETAIL_ENTITY : ParameterDetailEntity = {
    id: 0,
    key: "",
    versionIdentifier: {},
    parentDtlId: null,
    parameterId: null,
    parameterDtlCode: "",
    parameterDtlDesc: null,
    activeInd: "Y",
}